import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseFormComponent } from './base-form.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [BaseFormComponent],
  exports: [
    // BaseFormComponent
  ],
})
export class BaseFormModule {}
